import React, { Component } from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduce, indexOf, map } from 'lodash';
import { getTablePreference } from '../../modules/App/AppReducer';
import { fetchColumnsData } from './actions';

const RESOURCE_TYPE = {
  OPPORTUNITY: 'OPPORTUNITY',
  ACCOUNT: 'ACCOUNT',
  USER: 'USER',
  PRODUCT: 'PRODUCT',
  COMPETITOR: 'COMPETITOR',
};

class ColumnDataManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colIds: {},
    };
  }

  componentDidMount() {
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  checkProps(props) {
    const { columns, forceLoadSystemColumnTags } = props;
    const { colIds } = this.state;
    const currentColIds = { ...colIds };
    const newColIds = { ...colIds };
    const goodColumnIds = reduce(columns, (items, column) => {
      const targetField = column.target_field ? column.target_field : column.target_custom_meta_id;
      const k = `${column._id}:${column.target_object}:${targetField}`;
      const shouldLoad = !column.is_system || (column.is_system && indexOf(forceLoadSystemColumnTags, column.tag) >= 0)
      if (column.is_visible && shouldLoad && !currentColIds[k]) {
        items.push(column._id);
        newColIds[k] = true;
      }
      return items;
    }, []);
    this.setState({ colIds: newColIds }, () => {
      if (goodColumnIds.length) {
        this.loadColumns(goodColumnIds);
      }
    });
  }

  loadColumns(colIds) {
    const { resourceType } = this.props;
    const data = this.props.getRowData();
    let ids = [];
    if (resourceType === RESOURCE_TYPE.OPPORTUNITY) {
      ids = map(data, 'opportunity_id');
    } else if (resourceType === RESOURCE_TYPE.ACCOUNT) {
      ids = map(data, 'account_id');
    } else if (resourceType === RESOURCE_TYPE.USER) {
      ids = map(data, 'user_id');
    }
    if (ids.length) {
      this.props.onColumnLoading(colIds);
      this.props.dispatch(fetchColumnsData(colIds, ids, resourceType))
        .then(() => {
          this.props.onColumnLoaded(colIds);
        });
    }
  }

  render() {
    return null;
  }
}


ColumnDataManager.propTypes = {
  dispatch: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line
  resourceType: PropTypes.string,
  getRowData: PropTypes.func,
  onColumnLoading: PropTypes.func,
  onColumnLoaded: PropTypes.func,
  forceLoadSystemColumnTags: PropTypes.arrayOf(PropTypes.string),
};
ColumnDataManager.defaultProps = {
  columns: [],
  getRowData: () => [],
  resourceType: null,
  onColumnLoading: () => {},
  onColumnLoaded: () => {},
  forceLoadSystemColumnTags: [],
};


function mapStateToProps(state, ownProps) {
  return {
    columns: getTablePreference(state, ownProps.id),
  };
}

ColumnDataManager.RESOURCE_TYPE = RESOURCE_TYPE;

export default connect(mapStateToProps)(ColumnDataManager);
